import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AuthenticationService } from '../../services/authentication.service';
import { TasksService } from '../../services/tasks.service';

import * as moment from 'moment/moment';

import { CalendarEvent } from 'angular-calendar';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  view: string = 'month';
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];
  public results: any;
  public loading: boolean;
  public today = moment().startOf('day');
  public dailyDetails: any;
  public activeDate: Date = new Date();

  constructor(private AuthenticationService: AuthenticationService, private TasksService: TasksService) { }

  ngOnInit() {
    this.getDailyResults(moment());
    this.getDailyDetails(new Date());
  }

  getDailyResults(date) {
    this.loading = true;
    var date1 = moment(date).startOf('month');
    var date2 = moment(date).endOf('month');
    this.TasksService.getDailyResults(this.AuthenticationService.id(), moment(date1).utc().format('YYYY-MM-DD'), moment(date2).utc().format('YYYY-MM-DD')).subscribe(
      (data: Array<any>) => {
        this.loading = false;
        var results = data.reduce(function(map, obj) {
          map[obj._id] = { "result": obj.win };
          return map;
        }, {});
        this.results = results;
      }
    );
  }

  checkForResult(date) {
    if(moment(date).isSame(this.viewDate, 'month')){
      var dayOfYear = moment(date).dayOfYear();
      if(this.results[dayOfYear] && this.results[dayOfYear].result == true){
        return true;
      }
      else if(!this.results[dayOfYear]){
        return 'N/A'
      }
      else {
        return false;
      }
    }
  }

  getDailyDetails(date) {
    if(moment(date).isSame(this.viewDate, 'month')){
      this.activeDate = date;
      this.TasksService.getUserTasksByDay(this.AuthenticationService.id(), date).subscribe(
        data => { 
          this.dailyDetails = data;
        },
        err => console.error(err)
      );
    }
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/home/calendar/calendar.component.ts